// Что пользователь сделал сам, а не что пришло с сервера.
//
// Источники сообщают сюда после того, как сервер подтвердил ИХ запрос (свою
// задачу из очереди IN_TaskAdd, свой create/updateUsers в IN_ActionListChat,
// своё приглашение по почте). Данные, просто полученные с сервера (слепок,
// демо-задачи, действия других участников), сюда не попадают по построению.
//
// Это шина: источник не знает, кто слушает. Слушатели — Vuex-экшены
// `reportUserAction` в модулях (сейчас онбординг); в ненеймспейснутых модулях
// Vuex вызывает все одноимённые экшены, поэтому новый слушатель добавляется
// без правки источников.
export const USER_ACTION = Object.freeze({
  LIST_CREATED: "list_created",
  // задача или подзадача в списке projectId
  TASK_CREATED: "task_created",
  // в список projectId добавлен участник или ушло приглашение по почте
  LIST_MEMBER_ADDED: "list_member_added",
});

// Сообщить о действии. Стор без слушателей (юнит-тесты компонентов с
// урезанным стором) — не ошибка: действие просто никому не нужно.
export function reportUserAction(store, type, projectId) {
  if (!store || !store._actions || !store._actions.reportUserAction) {
    return Promise.resolve();
  }
  return store.dispatch("reportUserAction", {
    type,
    projectId: projectId == null ? null : String(projectId),
  });
}
